import * as actions from "store/actions/user/edit";
import IUser from "Types/User";

export interface UserEditState extends IUser {
	loading: boolean;
	item: IUser | null;
	errors: any;

}

const initialState: UserEditState = {
	loading: false,
	item: null,
	name: "",
	lastname: "",
	email: "",
	role: "",
	roles: [],
	phoneNumber: "",
	birthDate: undefined,
	status: 0,
	userStatus: 1,
	bankStatus: 0,
	avatar: "",
	cpf: "",
	mei: undefined,
	address: {
		street: "",
		number: "",
		complement: "",
		neighborhood: "",
		city: "",
		state: "",
		country: "",
		zipCode: ""
	},
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.GET_USER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_USER_SUCCESS: {
			return {
				...initialState,
				...payload,
				phoneNumber:
					payload.phoneNumber?.replace("+55", "").match(/\d/g)?.join("") ?? "",
				role: payload.roles.find((c: any) => c !== "user"),
				item: payload
			};
		}
		case actions.GET_USER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.EDIT_USER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.EDIT_USER_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.EDIT_USER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
